import React, { useEffect, useState } from 'react';
import api from '../api';
import BulkImport from '../components/BulkImport';

// ✅ Accept userRole prop from App.js
function Items({ userRole = 'owner' }) {
  const [items,      setItems]      = useState([]);
  const [form,       setForm]       = useState({
    name: '', name_tamil: '', quantity: '', price: '', mrp: '', barcode: ''
  });
  const [editItem,   setEditItem]   = useState(null);   // full edit modal
  const [editForm,   setEditForm]   = useState({});
  const [message,    setMessage]    = useState('');
  const [error,      setError]      = useState('');
  const [search,     setSearch]     = useState('');
  const [showImport, setShowImport] = useState(false);

  // ✅ Role permissions
  const canAdd    = userRole === 'owner' || userRole === 'staff';
  const canEdit   = userRole === 'owner' || userRole === 'staff';
  const canDelete = userRole === 'owner' || userRole === 'staff';
  const canImport = userRole === 'owner' || userRole === 'staff';

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = () => {
    api.get('/items/')
      .then(res => setItems(res.data || []))
      .catch(() => {});
  };

  // ─── ADD ITEM ───────────────────────────────
  const addItem = () => {
    if (!canAdd) return;
    if (!form.name || !form.quantity || !form.price) {
      setError('❌ பெயர், அளவு, விலை கட்டாயம்!'); return;
    }
    const mrpVal = form.mrp ? parseFloat(form.mrp) : null;
    if (mrpVal !== null && mrpVal < parseFloat(form.price)) {
      setError('❌ MRP, selling price-ஐ விட குறைவாக இருக்கக்கூடாது!'); return;
    }
    api.post('/items/', {
      name:            form.name,
      name_tamil:      form.name_tamil || '',
      quantity:        parseFloat(form.quantity),
      price:           parseFloat(form.price),
      mrp:             mrpVal,
      low_stock_alert: 10,
      barcode:         form.barcode || null,
    })
    .then(() => {
      setMessage('✅ பொருள் சேர்க்கப்பட்டது!');
      setError('');
      setForm({ name: '', name_tamil: '', quantity: '', price: '', mrp: '', barcode: '' });
      fetchItems();
      setTimeout(() => setMessage(''), 3000);
    })
    .catch(err => setError('❌ ' + (err.response?.data?.detail || err.message)));
  };

  // ─── OPEN EDIT MODAL ───────────────────────
  const openEdit = (item) => {
    if (!canEdit) return;
    setEditItem(item);
    setEditForm({
      name:       item.name       || '',
      name_tamil: item.name_tamil || '',
      quantity:   item.quantity   ?? '',
      price:      item.price      ?? '',
      mrp:        item.mrp        ?? '',
      barcode:    item.barcode    || '',
    });
  };

  // ─── SAVE EDIT ─────────────────────────────
  const saveEdit = () => {
    if (!editItem) return;
    const mrpVal = editForm.mrp !== '' ? parseFloat(editForm.mrp) : null;
    if (mrpVal !== null && mrpVal < parseFloat(editForm.price)) {
      setError('❌ MRP, selling price-ஐ விட குறைவாக இருக்கக்கூடாது!'); return;
    }
    api.put(`/items/${editItem.id}`, {
      name:            editForm.name       || undefined,
      name_tamil:      editForm.name_tamil || undefined,
      quantity:        editForm.quantity !== '' ? parseFloat(editForm.quantity) : undefined,
      price:           editForm.price    !== '' ? parseFloat(editForm.price)    : undefined,
      mrp:             mrpVal,
      barcode:         editForm.barcode  || undefined,
    })
    .then(() => {
      setMessage('✅ Updated!');
      setEditItem(null);
      fetchItems();
      setTimeout(() => setMessage(''), 3000);
    })
    .catch(err => setError('❌ ' + (err.response?.data?.detail || err.message)));
  };

  // ─── DELETE ────────────────────────────────
  const deleteItem = (id) => {
    if (!canDelete) return;
    if (!window.confirm('Delete பண்ணவா?')) return;
    api.delete(`/items/${id}`)
      .then(res => {
        setMessage(res.data.message || '✅ Deleted!');
        fetchItems();
        setTimeout(() => setMessage(''), 3000);
      })
      .catch(err => setError('❌ ' + (err.response?.data?.detail || err.message)));
  };

  const filtered = items.filter(i =>
    i.name?.toLowerCase().includes(search.toLowerCase()) ||
    i.name_tamil?.includes(search) ||
    (i.barcode && i.barcode.includes(search))
  );

  return (
    <div style={s.page}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px' }}>
        <h1 style={s.title}>பொருட்கள் நிர்வாகம் 📦</h1>
        <span style={{
          padding:'4px 12px', borderRadius:'20px', fontSize:'12px', fontWeight:'700',
          background: userRole==='cashier'?'#EBF5FB': userRole==='viewer'?'#F3E5F5':'#E8F8F0',
          color:      userRole==='cashier'?'#3498DB': userRole==='viewer'?'#9B59B6':'#27AE60',
        }}>
          {userRole==='owner'?'👑 Owner': userRole==='staff'?'👤 Staff':
           userRole==='cashier'?'💰 Cashier':'👁️ Viewer'}
        </span>
      </div>

      {/* ─── ADD FORM ─── */}
      {canAdd && (
        <div style={s.form}>
          <h3 style={s.formTitle}>➕ புது பொருள்</h3>

          {message && <div style={s.success}>{message}</div>}
          {error   && (
            <div style={s.err}>{error}
              <span style={{cursor:'pointer'}} onClick={()=>setError('')}>✕</span>
            </div>
          )}

          {/* Row 1: name + tamil */}
          <div style={s.grid2}>
            <input style={s.input} placeholder="Item Name *"
              value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/>
            <input style={s.input} placeholder="தமிழ் பெயர்"
              value={form.name_tamil} onChange={e=>setForm({...form,name_tamil:e.target.value})}/>
          </div>

          {/* Row 2: qty + selling price + mrp */}
          <div style={s.grid3}>
            <div>
              <label style={s.label}>அளவு *</label>
              <input style={s.input} placeholder="0" type="number" step="0.25"
                value={form.quantity} onChange={e=>setForm({...form,quantity:e.target.value})}/>
            </div>
            <div>
              <label style={s.label}>விற்பனை விலை ₹ * <span style={{color:'#27ae60'}}>(Selling Price)</span></label>
              <input style={s.input} placeholder="0.00" type="number"
                value={form.price} onChange={e=>setForm({...form,price:e.target.value})}/>
            </div>
            <div>
              <label style={s.label}>MRP ₹ <span style={{color:'#888'}}>(Packet price — optional)</span></label>
              <input style={{...s.input, borderColor: form.mrp ? '#e67e22' : '#ddd'}}
                placeholder="0.00" type="number"
                value={form.mrp} onChange={e=>setForm({...form,mrp:e.target.value})}/>
            </div>
          </div>

          {/* Row 3: barcode */}
          <div style={{marginBottom:'12px'}}>
            <label style={s.label}>📦 Barcode <span style={{color:'#888'}}>(manual type அல்லது scanner)</span></label>
            <input style={s.input} placeholder="Barcode number (optional)"
              value={form.barcode} onChange={e=>setForm({...form,barcode:e.target.value})}/>
          </div>

          {/* MRP info box */}
          {form.price && form.mrp && parseFloat(form.mrp) > parseFloat(form.price) && (
            <div style={s.savingInfo}>
              💡 Customer saving: ₹{(parseFloat(form.mrp) - parseFloat(form.price)).toFixed(2)} per item
              — Bill-ல் "TODAY SAVING" காட்டும்!
            </div>
          )}

          <button style={s.addBtn} onClick={addItem}>➕ சேர்க்க</button>
        </div>
      )}

      {!canAdd && message && <div style={s.success}>{message}</div>}
      {!canAdd && error   && (
        <div style={s.err}>{error}
          <span style={{cursor:'pointer'}} onClick={()=>setError('')}>✕</span>
        </div>
      )}

      {/* Bulk Import */}
      {canImport && (
        <div style={{marginBottom:'15px'}}>
          <button onClick={()=>setShowImport(true)}
            style={{background:'#27AE60',color:'#fff',border:'none',
                    padding:'10px 18px',borderRadius:'8px',cursor:'pointer',fontWeight:'700'}}>
            📥 Bulk Import / Export
          </button>
        </div>
      )}

      {!canAdd && (
        <div style={{background:'#FFF9E6',border:'1px solid #C9A84C',borderRadius:'8px',
                     padding:'10px 14px',marginBottom:'14px',fontSize:'13px',color:'#856404'}}>
          👁️ View only mode — Items add/edit/delete access இல்லை!
        </div>
      )}

      <input style={s.search} placeholder="🔍 Search by name, Tamil, barcode..."
        value={search} onChange={e=>setSearch(e.target.value)}/>

      {/* TABLE */}
      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>பெயர்</th>
              <th style={s.th}>தமிழ்</th>
              <th style={s.th}>அளவு</th>
              <th style={s.th}>விற்பனை விலை</th>
              <th style={s.th}>MRP</th>
              <th style={s.th}>Saving</th>
              <th style={s.th}>Barcode</th>
              <th style={s.th}>நிலை</th>
              {(canEdit||canDelete) && <th style={s.th}>Action</th>}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={9} style={s.empty}>Items இல்லை!</td></tr>
            ) : (
              filtered.map((item, i) => {
                const saving = item.mrp && item.price ? (parseFloat(item.mrp) - parseFloat(item.price)) : 0;
                return (
                  <tr key={item.id} style={{backgroundColor:i%2===0?'white':'#f8f9fa'}}>
                    <td style={s.td}><strong>{item.name}</strong></td>
                    <td style={s.td}>{item.name_tamil||'—'}</td>
                    <td style={s.td}>
                      {Number(item.quantity)%1===0 ? item.quantity : Number(item.quantity).toFixed(2)}
                    </td>
                    {/* Selling Price */}
                    <td style={s.td}>
                      <span style={{fontWeight:'700',color:'#2c3e50'}}>₹{item.price}</span>
                    </td>
                    {/* MRP */}
                    <td style={s.td}>
                      {item.mrp
                        ? <span style={{color:'#e67e22',fontWeight:'600'}}>₹{item.mrp}</span>
                        : <span style={{color:'#ccc'}}>—</span>}
                    </td>
                    {/* Customer Saving */}
                    <td style={s.td}>
                      {saving > 0
                        ? <span style={{color:'#27ae60',fontWeight:'700',fontSize:'13px'}}>
                            💚 ₹{saving.toFixed(2)}
                          </span>
                        : <span style={{color:'#ccc'}}>—</span>}
                    </td>
                    {/* Barcode */}
                    <td style={s.td}>
                      {item.barcode
                        ? <span style={{fontFamily:'monospace',fontSize:'12px',
                                        background:'#f0f0f0',padding:'2px 6px',borderRadius:'4px'}}>
                            {item.barcode}
                          </span>
                        : <span style={{color:'#ccc'}}>—</span>}
                    </td>
                    {/* Stock status */}
                    <td style={s.td}>
                      <span style={{
                        color: item.quantity<=(item.low_stock_alert||10)?'#e67e22':'#27ae60',
                        fontWeight:'600', fontSize:'13px',
                      }}>
                        {item.quantity<=(item.low_stock_alert||10)?'⚠️ குறைவு':'✅ சரி'}
                      </span>
                    </td>
                    {/* Action */}
                    {(canEdit||canDelete) && (
                      <td style={s.td}>
                        {canEdit && (
                          <button style={s.editBtn} onClick={()=>openEdit(item)} title="Edit">✏️</button>
                        )}
                        {canDelete && (
                          <button style={s.delBtn} onClick={()=>deleteItem(item.id)} title="Delete">🗑️</button>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* EDIT MODAL */}
      {editItem && (
        <div style={s.overlay} onClick={e=>e.target===e.currentTarget&&setEditItem(null)}>
          <div style={s.modal}>
            <div style={s.modalHeader}>
              <h3 style={{margin:0,color:'white'}}>✏️ Item திருத்து — {editItem.name}</h3>
              <button style={s.closeBtn} onClick={()=>setEditItem(null)}>✕</button>
            </div>
            <div style={{padding:'20px'}}>
              {error && (
                <div style={s.err}>{error}
                  <span style={{cursor:'pointer'}} onClick={()=>setError('')}>✕</span>
                </div>
              )}
              <div style={s.grid2}>
                <div>
                  <label style={s.label}>Item Name</label>
                  <input style={s.input} value={editForm.name}
                    onChange={e=>setEditForm({...editForm,name:e.target.value})}/>
                </div>
                <div>
                  <label style={s.label}>தமிழ் பெயர்</label>
                  <input style={s.input} value={editForm.name_tamil}
                    onChange={e=>setEditForm({...editForm,name_tamil:e.target.value})}/>
                </div>
              </div>
              <div style={s.grid3}>
                <div>
                  <label style={s.label}>அளவு</label>
                  <input style={s.input} type="number" step="0.25" value={editForm.quantity}
                    onChange={e=>setEditForm({...editForm,quantity:e.target.value})}/>
                </div>
                <div>
                  <label style={s.label}>விற்பனை விலை ₹</label>
                  <input style={s.input} type="number" value={editForm.price}
                    onChange={e=>setEditForm({...editForm,price:e.target.value})}/>
                </div>
                <div>
                  <label style={s.label}>MRP ₹ (Packet price)</label>
                  <input style={{...s.input, borderColor:'#e67e22'}} type="number" value={editForm.mrp}
                    onChange={e=>setEditForm({...editForm,mrp:e.target.value})}
                    placeholder="Leave empty = no MRP"/>
                </div>
              </div>
              <div>
                <label style={s.label}>Barcode</label>
                <input style={s.input} value={editForm.barcode}
                  onChange={e=>setEditForm({...editForm,barcode:e.target.value})}
                  placeholder="Barcode scan அல்லது manual type"/>
              </div>
              {editForm.price && editForm.mrp && parseFloat(editForm.mrp) > parseFloat(editForm.price) && (
                <div style={{...s.savingInfo, marginTop:'10px'}}>
                  💡 Customer saving: ₹{(parseFloat(editForm.mrp)-parseFloat(editForm.price)).toFixed(2)} per item
                </div>
              )}
              <div style={{display:'flex',gap:'10px',marginTop:'16px'}}>
                <button style={s.addBtn} onClick={saveEdit}>💾 சேமி</button>
                <button style={{...s.addBtn,background:'#95a5a6'}} onClick={()=>setEditItem(null)}>ரத்து</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImport && (
        <BulkImport onClose={()=>setShowImport(false)} onSuccess={fetchItems}/>
      )}
    </div>
  );
}

const s = {
  page:       {padding:'20px',maxWidth:'1200px',margin:'0 auto'},
  title:      {color:'#2c3e50',marginBottom:0},
  form:       {background:'#f9f9f9',border:'1px solid #eee',borderRadius:'12px',
               padding:'20px',marginBottom:'20px'},
  formTitle:  {color:'#2c3e50',marginBottom:'14px'},
  label:      {display:'block',fontSize:'12px',fontWeight:'700',color:'#555',
               marginBottom:'4px',textTransform:'uppercase',letterSpacing:'0.3px'},
  grid2:      {display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'12px'},
  grid3:      {display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'10px',marginBottom:'12px'},
  input:      {padding:'10px 12px',borderRadius:'8px',border:'1px solid #ddd',
               fontSize:'14px',width:'100%',boxSizing:'border-box'},
  addBtn:     {background:'#2c3e50',color:'white',border:'none',padding:'10px 24px',
               borderRadius:'8px',cursor:'pointer',fontWeight:'700'},
  savingInfo: {background:'#e8f8f0',border:'1px solid #27ae60',color:'#1e8449',
               padding:'10px 14px',borderRadius:'8px',marginBottom:'12px',fontSize:'13px'},
  success:    {background:'#e8f8f0',border:'1px solid #27ae60',color:'#27ae60',
               padding:'10px',borderRadius:'8px',marginBottom:'12px'},
  err:        {background:'#fff0f0',border:'1px solid #e74c3c',color:'#e74c3c',
               padding:'10px',borderRadius:'8px',marginBottom:'12px',
               display:'flex',justifyContent:'space-between'},
  search:     {width:'100%',padding:'10px 14px',borderRadius:'8px',border:'1px solid #ddd',
               fontSize:'14px',marginBottom:'14px',boxSizing:'border-box'},
  tableWrap:  {background:'white',borderRadius:'12px',overflow:'auto',border:'1px solid #eee'},
  table:      {width:'100%',borderCollapse:'collapse'},
  thead:      {background:'#2c3e50'},
  th:         {padding:'12px 16px',color:'white',fontSize:'13px',fontWeight:'600',textAlign:'left'},
  td:         {padding:'11px 16px',borderBottom:'1px solid #f0f0f0',fontSize:'14px'},
  empty:      {textAlign:'center',padding:'30px',color:'#999'},
  editBtn:    {background:'#3498db',color:'white',border:'none',padding:'6px 10px',
               borderRadius:'6px',cursor:'pointer',marginRight:'6px'},
  delBtn:     {background:'#e74c3c',color:'white',border:'none',padding:'6px 10px',
               borderRadius:'6px',cursor:'pointer'},
  // Modal
  overlay:    {position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:1000,
               display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'},
  modal:      {background:'white',borderRadius:'12px',width:'100%',maxWidth:'600px',
               boxShadow:'0 20px 60px rgba(0,0,0,0.3)',overflow:'hidden'},
  modalHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',
               padding:'16px 20px',background:'#2c3e50'},
  closeBtn:   {background:'rgba(255,255,255,0.2)',border:'none',color:'white',
               width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'16px'},
};

export default Items;

